import './termo-responsabilidade-modal-controller';
import './lista-termos-de-uso-controller';
import './termo-uso-detalhe-controller';
import './aditivo-contratual-detalhe-controller';
import './aviso-de-privacidade-controller';
import './lista-aviso-de-privacidade-controller';
import './lista-aditivo-contratual-controller';
import './politica-de-cookies-controller';